export const TIMES = {
  DELAY_TIME: 1000,
};

export default TIMES;
